<template>
    <div class="xh-svh bg-dark-tp">
        <div class="xh-svh max-w-full sm:max-w-md flex flex-col justify-between mx-auto inset-y-0 right-0 py-5 border-r-0 sm:border-r border-l-0 sm:border-l border-gray-900 font-satoshi_r">
            <div class="">
                <img 
                    class="w-full bg-cover bg-no-repeat bg-center" 
                    src="@/assets/images/trendupp/awards_03.png" 
                    alt="TrendUpp Award"
                >

                <div class="mt-20 px-5">
                    <h3 class="text-1xl font-medium text-white">
                        Vote for the
                    </h3>
                    <h1 class="text-1xl uppercase font-medium text-cream-500 mb-2">
                        Emerging Force Category
                    </h1>
                    <p class="text-base font-medium text-gray-x10">
                        Content creators and influencers who are rated as the next big deal in social media between March 2024 - March 2025. 
                    </p>
                </div>
            </div>

            <div class="flex flex-col justify-end items-center px-8">
                <RouterLink 
                    :to="`/trendupp/vote?id=${$route.query?.id}`" 
                    class="button is-primary is-medium is-fullwidth font-satoshi_r"
                >
                    <span class="text-sm">Vote Now</span> 
                </RouterLink>

                <div class="flex items-center space-x-2 mt-4">
                    <span class="text-xs text-gray-x10 font-satoshi_r">
                        Powered by
                    </span>
                    <div class="w-18r">
                        <img src="@/assets/images/trendupp/sycamore_logo.png" alt="Sycamore Logo">
                    </div>
                </div>
            </div>
        </div>
    </div>
</template>

<script>
    export default {
        name: "TrendUpp",

        components: {
        },

        data() {
            return {}
        },

        methods: {
        },

        mounted() {
        },
    };
</script>

<style scoped>
    body {
        background-color: #000000;
    }

    .xh-svh {
        height: 100vh;
        height: 100svh !important;
    }

    .text-1xl {
        font-size: 1.375rem /* 22px */ ;
        line-height: 2rem /* 32px */ ;
    }

    .button {
        border-radius: 12px !important;
    }
</style>

